import type { FunctionComponent } from 'react'
import React from 'react'

import type { LinkAppearance } from '../../../../types'
import { InfoBox } from '../../../InfoBox'
import { TypographyV2 } from '../../../Seatbelt2/Foundations/Typography'
import { BasicInfoDownload } from '../BasicInfoDownload'
import { Print } from '../Print'
import styles from './ExtendedInfoDownload.module.scss'

export const ExtendedInfoDownload: FunctionComponent<
  ExtendedInfoDownloadProps
> = ({ file, url, infoBoxBorderColour = 'blue', label, buttonAppearance }) => (
  <InfoBox
    heading={file.name}
    byline="Free File Download"
    borderColour={infoBoxBorderColour}
    className={styles.container}
  >
    <div className={styles.layout}>
      <TypographyV2 textStyle="sb-text-interface-body-small-regular">
        {file.description}
      </TypographyV2>
      <BasicInfoDownload
        className={styles.button}
        file={file}
        url={url}
        label={label}
        buttonAppearance={buttonAppearance}
      />
      <Print file={file} url={url} />
    </div>
  </InfoBox>
)

///////// IMPLEMENTATION /////////

export type ExtendedInfoDownloadProps = {
  file: File
  url: string
  infoBoxBorderColour: InfoBoxBorderColour
  label: string
  buttonAppearance: LinkAppearance
}

export type File = {
  name?: string
  type: string
  size: number
  description?: string
  path: string
}

/*  move the below type to Button comp, once the latter is converted to TS */
export type InfoBoxBorderColour = 'red' | 'yellow' | 'green' | 'blue'
